import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Language, YEAR_DATE_FORMAT } from '../../common';
import { format } from 'date-fns';

@Component({
  selector: 'container-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultLayoutComponent {
  @Input() showIntrackLogo = true;

  @Input() showLanguage = true;

  @Input()
  isLogoAvailable = true;

  @Input()
  isFooterAvailable = true;

  @Input()
  language?: Language;

  @Output()
  languageFromSelect = new EventEmitter<Language>();

  currentYear: string = format(new Date(), YEAR_DATE_FORMAT);
}
